import { DOCUMENT_MODE } from "../../../constants/document";
import AddDocComponentCommand from "../addComponentCommandBase/addDocComponentCommand";
import AddTemplateComponentCommand from "../addComponentCommandBase/addTemplateComponentCommand";
import DummyCommand from "../dummyCommand";
import AddSignatureDocCommand from "./addSignatureDocCommand";
import AddSignatureTemplateCommand from "./addSignatureTemplateCommand";

class AddSignatureFactory {
  static getCommand(mode, isPDF, componentData) {
    if (isPDF && mode === DOCUMENT_MODE.DOCUMENT) {
      return new AddDocComponentCommand(componentData); // update later
    }
    if (isPDF && mode === DOCUMENT_MODE.TEMPLATE) {
      return new AddTemplateComponentCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new AddSignatureDocCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new AddSignatureTemplateCommand(componentData);
    }
    return new DummyCommand();
  }
}

export default AddSignatureFactory;
